import './style.scss'
import { useContext, useEffect, useState } from 'react'
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service'
import AppInfoContext, { AppInfoProvider } from 'src/provider/state-manager/appInfoProvider'
import { AppSpan, AppText, CustomContainer, ScreenContainer } from 'src/style'
import { ServerSideTable } from 'src/component'
import {allTransactionsColumns} from 'src/utils/tableLayout'
import {TransactionDetails} from 'src/popup'
import { useNavigate } from 'react-router-dom'


const AllTransactions = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [data, setData] = useState<any>(null)
    const [transactions, setTransactions] = useState<any>(null)
    const [selectedTransaction, setSelectedTransaction] = useState<any>(null)
    const [isTransactionDetails, setIsTransactionDetails] = useState(false)

    useEffect(() => {
        handleFetchTransactions()
    }, [])

    async function handleFetchTransactions (pageNumber = 1, pageSize = 10) {
        const response = await API.getAllTransactions(pageNumber, pageSize)
        if (response) {
            setData(response)
            setTransactions(response.data)
        }
    }

    async function handleSelectedRow(data: any) {
        setSelectedTransaction(data)
        setIsTransactionDetails(true)
    }

    return (
        <>
            <ScreenContainer
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                <CustomContainer>
                    <CustomContainer topMargin="1.5">
                        <AppText textSize="2" fontWeight="600" color="#181D27" bottomMargin="0.7">Transaction information</AppText>
                        <AppSpan color="#6F767C">View and manage crendly transactions</AppSpan>
                    </CustomContainer>
                    <CustomContainer topMargin="6">
                        <ServerSideTable
                            tableData={transactions}
                            tableColumns={allTransactionsColumns} 
                            dataFetchMethod={handleFetchTransactions}
                            totalRows={data?.totalTransactionsCount}
                            customStyle
                            canSearch
                            canDownload
                            reportFileName='CRENDLY_TRANSACTIONS'
                            onRowClickMethod={handleSelectedRow}
                        />
                    </CustomContainer>
                </CustomContainer>
            </ScreenContainer>
            { isTransactionDetails &&
                <TransactionDetails 
                    close={() => setIsTransactionDetails(false)}
                    data={selectedTransaction}
                />
            }
        </>
    )
}

export default utility.routeData('all-transactions', 'All Transaction', <AllTransactions/>)